import axios from 'axios';

const api = axios.create({
  // Vite: use VITE_API_URL (empty string = same-origin / Nginx /api proxy)
  baseURL: (import.meta.env.VITE_API_URL || '') + '/api',
});

// Automatically inject the token into EVERY request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// RESPONSE interceptor to catch 401s
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config.url.includes('/auth/login');

      if (!isLoginRequest) {
        console.warn('Unauthorized! Clearing session...');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
